import { Home } from '@web-platform/travel-tools-home/src';

import type { loader as rootLoader } from '../root';
import type { MetaFunction } from 'react-router';

export const meta: MetaFunction<unknown, { root: typeof rootLoader }> = ({ matches }) => {
  const rootMatch = matches.find((m) => m.id === 'root');
  const translations = rootMatch?.data?.i18n?.translations;
  if (!translations) return [];
  return [
    { title: translations.travel_tools_meta_title },
    { name: 'description', content: translations.travel_tools_meta_description },
    { property: 'og:title', content: translations.travel_tools_meta_title },
    { property: 'og:description', content: translations.travel_tools_meta_description },
  ];
};

export default function TravelToolsHome() {
  return <Home />;
}
